/**
 * Centralized Role Definitions
 * 
 * This file contains the single source of truth for all user roles and permission levels
 * in the Aegis application. Use these constants instead of hardcoded strings.
 * 
 * NOTE: This file is deprecated. Use src/lib/rbac.ts instead, which contains the canonical
 * role definitions and types.
 */

export const ROLES = {
    // System Administration (DEPRECATED: Use rbac.ts ADMIN_ROLES)
    SUPER_ADMIN: 'platform_admin',
    PLATFORM_ADMIN: 'platform_admin',
    ADMIN: 'platform_admin',

    // Partner Ecosystem (DEPRECATED: Use rbac.ts PARTNER_ROLES)
    PARTNER: 'partner_viewer',
    PARTNER_ADMIN: 'partner_admin',
    PARTNER_DEVELOPER: 'partner_viewer',
    PARTNER_SUPPORT: 'partner_viewer',

    // Organizational (DEPRECATED: Use rbac.ts ENTERPRISE_ROLES)
    ORG_OWNER: 'org_owner',
    ORG_ADMIN: 'org_admin',

    // Standard User (DEPRECATED: Use rbac.ts CONSUMER_ROLES)
    USER: 'consumer',
} as const;

export type RoleValue = typeof ROLES[keyof typeof ROLES];

/**
 * Checks if a user has admin privileges (Platform or Super Admin)
 * @deprecated Use hasAnyRole() from rbac.ts instead
 */
export const isAdminRole = (role?: string | null): boolean => {
    if (!role) return false;
    return role === 'platform_admin';
};

/**
 * Checks if a user has partner privileges
 * @deprecated Use hasAnyRole() from rbac.ts instead
 */
export const isPartnerRole = (role?: string | null): boolean => {
    if (!role) return false;
    return role === 'partner_viewer' ||
        role === 'partner_admin' ||
        role.startsWith('partner_');
};;
